import { transition } from '@helpers/animate';
import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { paragraphRegular, paragraphSmall } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import styled from 'styled-components';
const Container = styled.a `
  display: flex;
  background-color: var(--bgColour);
  color: var(--colour);
  text-decoration: none;

  &[data-type='cta'] {
    --bgColour: ${brand.primary.purple};
    --colour: ${brand.primary.offWhite};
  }

  &[data-type='article'],
  &[data-type='event'] {
    --bgColour: ${brand.primary.offWhite};
    --colour: ${brand.primary.purple};
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }
`;
const ImageWrapper = styled.div `
  width: 42%;

  svg {
    ${transition('transform')};

    position: absolute;

    path {
      stroke-width: 0.5;
    }

    path:last-of-type {
      stroke: var(--lineColour, currentColor);
    }

    &:first-of-type {
      top: 6px;
      left: 6px;
      width: 50%;
      transform: rotate(7deg);
    }

    &:last-of-type {
      right: 8px;
      bottom: 8px;
      width: 33%;
      transform: rotate(-9deg);
    }
  }
`;
const ImageInner = styled.div `
  position: relative;
  height: 100%;
  width: 100%;
  overflow: clip;
  overflow: hidden;
  min-height: 267px;
`;
const Image = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()};

  ${Container}.focus-ring &,
  ${Container}:hover & {
    transform: scale(1.1);
  }
`;
const ContentWrapper = styled.div `
  position: relative;
  padding: ${fluid(16, 20)} ${fluid(24, 28)};
  width: 58%;
  display: flex;
`;
const TopWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  width: 100%;
`;
const TimeWrapper = styled.span `
  margin: calc(${fluid(16, 20)} * -1) calc(${fluid(8, 10)} * -1) ${fluid(8, 12)} auto;
  background-color: var(--colour);
  color: var(--bgColour);
  padding: 6px 10px 7px;
  border-radius: 0 0 4px 4px;
  flex-shrink: 0;
`;
const Time = styled.time `
  ${paragraphSmall};

  margin: 0;
`;
const Pillwrapper = styled.div `
  margin: 0 0 ${fluid(16, 20)};
`;
const ContentInner = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  ${Container}[data-type='article'] &,
  ${Container}[data-type='event'] & {
    border-left: 1px solid var(--colour);
    padding-left: ${fluid(16, 20)};
  }

  > svg {
    ${transition('transform')};

    display: block;
    width: ${fluid(18, 20)};
    margin: 4px 0 0 auto;

    ${Container}.focus-ring &,
    ${Container}:hover & {
      transform: translateX(15%);
    }
  }

  > ${ButtonStyles.Button} {
    margin: ${fluid(24, 28)} 0 0;
  }
`;
const Title = styled.span `
  ${paragraphRegular};
  ${fonts.graphikCompact.semibold};

  margin: 0;
`;
const Subtitle = styled.span `
  ${paragraphSmall};
  ${fonts.graphikCompact.semibold};

  margin: 4px 0 0;
`;
const Content = styled.p `
  ${paragraphSmall};

  margin: 20px 0 0;
`;
const FeaturedCardStyles = {
    Container,
    ImageWrapper,
    Image,
    ImageInner,
    ContentWrapper,
    ContentInner,
    TimeWrapper,
    Time,
    Title,
    Subtitle,
    Content,
    Pillwrapper,
    TopWrapper,
};
export default FeaturedCardStyles;
